/* global $:true */
// Modified from https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video
import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/lazy-load';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-lazy-load]';
const LAZY_LOAD_SRC_ATTR = 'data-lazy-load-src';
const LAZY_LOAD_SRCSET_ATTR = 'data-lazy-load-srcset';
const LAZY_LOAD_BACKGROUND_ID_ATTR = 'data-lazy-load-block-id';
const SRC_ATTR = 'src';

class LazyLoad {

	constructor (element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.lazyLoadSrc = this.$element.attr(LAZY_LOAD_SRC_ATTR);
		this.lazyLoadSrcSet = this.$element.attr(LAZY_LOAD_SRCSET_ATTR);
		this.backgroundIdAttr = this.$element.attr(LAZY_LOAD_BACKGROUND_ID_ATTR);

		log('LazyLoad', element);
		this.init();
	}

	init () {
		var module = this;
		if ("IntersectionObserver" in window) {
		    this.lazyImageObserver = new IntersectionObserver(function(entries, observer) {
		      entries.forEach(function(entry) {
		        if (entry.isIntersecting) {
		         	module.setImageSrc();
		        }
		      });
		    });

			this.watch();
	  	}
	  	else {
	  		this.setImageSrc();
	  	}
	}

	setImageSrc() {
		if (typeof(this.lazyLoadSrc) !== 'undefined') {
	    	this.element.src = this.lazyLoadSrc;
	    }
	    if (typeof(this.lazyLoadSrcSet) !== 'undefined') {
	    	this.element.srcset = this.lazyLoadSrcSet;
	    }
	    if (typeof(this.lazyImageObserver) !== 'undefined') {
	    	this.lazyImageObserver.unobserve(this.element);
	    }
	    if (typeof(this.backgroundIdAttr) !== 'undefined') {
	    	this.$element.attr('id', this.backgroundIdAttr);
	    }
	    this.$element.addClass('lazyloaded');
	}

	watch() {
 		this.lazyImageObserver.observe(this.element);
	}
}

LazyLoad.DEFAULTS = {
};


plugin('lazyLoad', LazyLoad);

export function exec () {
	$(document).ready(() => {
		log('binding');
		$(ELEMENT_SELECTOR).lazyLoad();
		$(document).on('product-teasers-loaded', function(){
            $(ELEMENT_SELECTOR).lazyLoad();
		});
		log('bound');
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/lazy-load/index.js